import { render, staticRenderFns } from "./ResidentialSettings.vue?vue&type=template&id=1916b394"
import script from "./ResidentialSettings.vue?vue&type=script&lang=js"
export * from "./ResidentialSettings.vue?vue&type=script&lang=js"
import style0 from "./ResidentialSettings.vue?vue&type=style&index=0&id=1916b394&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports